var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdviceLightmode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_882_918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4 5H5V7.4H19.4V5Z",
    fill: "#000433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1998 8.6001H9.7998V11.0001H15.1998V8.6001Z",
    fill: "#FC3165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17.6001V8.6001H7.4V14.0001L10.16 12.8001H17V8.6001H19.4V15.2001H10.64L5 17.6001Z",
    fill: "#000433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 22.5201L17.9001 20.0001H11.6001V16.4001H14.0001V17.6001H18.5001L20.6001 18.6801V8.6001H23.0001V22.5201Z",
    fill: "#FC3165"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_882_918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(5 5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdviceLightmode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/advice-lightmode.8e8f3eb07dc6f2ddaca405e30366d980.svg";